/**
 * RequestDetails — Facility search and confirmation.
 * Mixed into RequestDetails.prototype.
 */
import { apiClient } from '../../utils/ApiClient.js';

export const FacilityMixin = {

    escapeHtml(str) {
        const div = document.createElement('div');
        div.textContent = str == null ? '' : String(str);
        return div.innerHTML;
    },

    decodeHtml(str) {
        const div = document.createElement('div');
        div.innerHTML = str == null ? '' : String(str);
        return div.textContent;
    },

    safeText(str) {
        return this.escapeHtml(this.decodeHtml(str));
    },

    openConfirmFacilityModal() {
        this.initConfirmFacilityModal();
        if (!this.confirmFacilityModal) return;

        this.fillConfirmFacilityCurrent();
        const search   = document.getElementById('confirm_facility_search');
        const results  = document.getElementById('confirm_facility_results');
        const selected = document.getElementById('confirm_facility_selected_id');
        if (search)   search.value     = '';
        if (results)  results.innerHTML = '';
        if (selected) selected.value   = '';

        this.confirmFacilityModal.open();
    },

    fillConfirmFacilityCurrent() {
        const trigger = this.details?.querySelector('#confirm_facility_btn');
        const ds      = trigger?.dataset || {};
        const nameEl  = document.getElementById('confirm_facility_current_name');
        const phoneEl = document.getElementById('confirm_facility_current_phone');
        const addrEl  = document.getElementById('confirm_facility_current_address');
        if (!nameEl || !phoneEl || !addrEl) return;
        nameEl.textContent  = (ds.facilityName    || '').trim() || '—';
        phoneEl.textContent = (ds.facilityPhone   || '').trim() || '—';
        addrEl.textContent  = (ds.facilityAddress || '').trim() || '—';
    },

    async searchFacilities(q) {
        const resultsEl = document.getElementById('confirm_facility_results');
        if (!resultsEl) return;

        const trimmed = (q || '').trim();
        if (trimmed.length < 2) {
            resultsEl.innerHTML = '';
            return;
        }

        try {
            const json = await apiClient.post('docuswift_search_parent_facilities', { q: trimmed });
            if (!json.success) {
                resultsEl.innerHTML = '<p>Search failed.</p>';
                return;
            }
            this.renderFacilityResults(json.data?.results || []);
        } catch (err) {
            console.error(err);
            resultsEl.innerHTML = '<p>Search failed.</p>';
        }
    },

    renderFacilityResults(items) {
        const resultsEl = document.getElementById('confirm_facility_results');
        if (!resultsEl) return;
        if (!items.length) {
            resultsEl.innerHTML = '<p class="no-matches-found">No matches found for the facility. You can also <span id="add_new_facility_link">add new facility.</span></p>';
            return;
        }
        resultsEl.innerHTML = items.map((item) => this.renderFacilityResultCard(item)).join('');
    },

    renderFacilityResultCard(item) {
        const id    = this.escapeHtml(item.id);
        const name  = this.safeText(item.name);
        const phone = this.safeText(item.phone || '—');
        const email = this.safeText(item.email || '—');
        const addr  = this.safeText(item.address || '');
        const depts = (item.departments || []).map((d) => this.renderFacilityResultDept(d)).join('');
        const deptsHtml = depts ? `<div class="confirm-facility-result__depts">${depts}</div>` : '';
        const chevronSvg = `<svg class="confirm-facility-result__chevron" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 6l5 5 5-5"/></svg>`;

        return (
            `<div class="confirm-facility-result" data-facility-id="${id}">` +
                `<div class="confirm-facility-result__header">` +
                    `<div class="confirm-facility-result__info">` +
                        `<span class="confirm-facility-result__name">${name}</span>` +
                        `<span class="confirm-facility-result__sub">${phone} · ${email}</span>` +
                        `<span class="confirm-facility-result__sub">${addr ? addr : ''}</span>` +
                    `</div>` +
                    `<div class="confirm-facility-result__actions">` +
                        `<button type="button" class="button gold confirm-facility-result__edit" data-facility-id="${id}">View / Edit</button>` +
                    `</div>` +
                `</div>` +
                deptsHtml +
            `</div>`
        );
    },

    renderFacilityResultDept(dept) {
        const name      = this.safeText(dept.name || '');
        const typeName  = this.safeText(dept.type_name || '');
        const phone     = this.safeText(dept.phone || '');
        const email     = dept.email ? this.safeText(dept.email) : '';
        const address   = this.safeText(dept.address || '');
        const preferred = this.safeText(dept.preferred_method || '');
        const tagHtml   = typeName ? `<span class="confirm-facility-dept__tag">${typeName}</span>` : '';
        const detail    = (label, value) => value
            ? `<div class="confirm-facility-dept__row"><span class="confirm-facility-dept__label">${label}</span><span class="confirm-facility-dept__val">${value}</span></div>`
            : '';
        const emailLink = email ? `<a href="mailto:${email}">${email}</a>` : '';

        return (
            `<div class="confirm-facility-dept">` +
                `<div class="confirm-facility-dept__details">` +
                    `<div class="confirm-facility-dept__grid">` +
                        detail('Department type', typeName) +
                        detail('Department name', name) +
                        detail('Preferred method', preferred) +
                        detail('Phone', phone) +
                        detail('Email', emailLink) +
                        detail('Address', address) +
                    `</div>` +
                `</div>` +
            `</div>`
        );
    },

    async submitConfirmFacility() {
        if (!this.activeRequestId) return;
        const hidden     = document.getElementById('confirm_facility_selected_id');
        const facilityId = hidden && hidden.value ? String(hidden.value).trim() : '';
        try {
            const json = await apiClient.post('docuswift_apply_request_facility', {
                request_id:  String(this.activeRequestId),
                facility_id: facilityId,
            });
            if (json.success) {
                this.confirmFacilityModal?.close();
                this.fetchDetails(String(this.activeRequestId));
            } else {
                window.alert(json.data?.message || 'Could not update facility.');
            }
        } catch (err) {
            console.error(err);
            window.alert('Could not update facility.');
        }
    },
};
